export default __webpack_public_path__ + "static/media/stumpwithax.27fa6d70.png";